import {BaseEntity} from "../../entities/BaseEntity";
import { StateParams, StateService } from "@uirouter/angularjs";
import {EditModel} from "../../models/edit/EditModel";
import {NotificationService} from "../../services/NotificationService";

export class EditBaseCtrl<T extends BaseEntity> {
    id:number;
    constructor(public $scope:any,
                public stateService:StateService,
                public stateParamsService:StateParams,
                public notifyService:NotificationService,
                public model:EditModel<T>) {
        $scope.vm = this;
    }
    pagingRoute():string{
        return "";
    }
    loadData():ng.IPromise<boolean>{
        var id:number = parseInt(this.stateParamsService["id"]);
        if(isNaN(id))
          id = null;
        this.id = id;
        return this.model.loadData(id);
    }

    save():void{
        this.model.saveData().then((ok)=>{
          if(ok)
            this.stateService.go(this.pagingRoute());
        }).catch((exc)=>{
            this.notifyService.notifyError("Error saving:"+exc);
        });
    }
    cancel():void{
        this.stateService.go(this.pagingRoute());
    }
}
